import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { DefaultDataService } from './default-data.service';
import { WebAPIResult } from './employee.service';
import { EventService } from './event.service';

export class OnlineSalesSettings {
  AllowOnlineSales: boolean = false;
  Credentials: OnlineSalesCredentials;
  OnlineSalesWelcomeText: string = '';
  OnlineSalesConfirmationText: string = '';
  SendOnlineSummaryEmail: boolean = false;
  OnlineSummaryEmail: string = '';
  OnlineSummaryEmailRecipients: string[] = [];
  HourToSendOnlineSummaryEmail: number = 23;
  ApiUsername: string = '';
  ApiPassword: string = '';
  MerchantId: string = '';
  MerchantDescription: string = '';
}

export class OnlineSalesCredentials {}

@Injectable({
  providedIn: 'root',
})
export class OnlineSalesService {
  url = '/api/BackOffice/OnlineSalesSettings';

  constructor(private http: HttpClient, private defaultData: DefaultDataService, private events: EventService) {}

  getOnlineSalesSettings() {
    return this.http.get<OnlineSalesSettings>(this.url);
  }

  saveOnlineSalesSettings(onlineSalesSettings: OnlineSalesSettings) {
    return this.http.post<WebAPIResult>(this.url, onlineSalesSettings).pipe(
      take(1),
      catchError((e) => {
        return of(e as WebAPIResult);
      }),
      tap((r) => {
        this.defaultData.defData.onlineSalesSettings = onlineSalesSettings;
        this.events.DefaultDataChanged(this.defaultData.defData);

        return r as WebAPIResult;
      })
    );
  }
}
